import React from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Card,
  Box,
  Typography,
  Grid,
  Stack,
} from "@mui/material";
import {
  Mail,
  HelpCircle,
  Send,
} from "lucide-react";
import { colors, borderRadiusPx, customShadows } from "../../../../../theme";
import { CommonButton } from "../../../../Components/ui";
import { Path } from "../../../../../static/Constants";

const TermsContactNotice = () => {
  const history = useHistory();

  return (
    <Card
      sx={{
        p: { xs: 3, sm: 4 },
        borderRadius: borderRadiusPx.xl,
        backgroundColor: colors.dashboard.cardBg,
        border: `1px solid ${colors.dashboard.cardBorder}`,
        boxShadow: customShadows.cardFlat,
      }}
    >
      <Grid container spacing={3} alignItems="center" justifyContent="space-between">
        <Grid item xs={12} md={8}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              sx={{
                width: 48,
                height: 48,
                minWidth: 48,
                borderRadius: borderRadiusPx.lg,
                bgcolor: colors.blue[50],
                color: colors.primary.main,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Mail size={24} />
            </Box>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 800, color: colors.slate[900], mb: 0.5, fontSize: "1.1rem" }}>
                Questions About Our Terms?
              </Typography>
              <Typography variant="body2" sx={{ color: colors.slate[600], lineHeight: 1.6 }}>
                For legal inquiries, partnership proposals, or clarification regarding these Terms, contact our compliance team directly at{" "}
                <Box
                  component="a"
                  href="mailto:info@autobetlottery.com"
                  sx={{
                    color: colors.primary.main,
                    fontWeight: 700,
                    textDecoration: "none",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  info@autobetlottery.com
                </Box>
              </Typography>
            </Box>
          </Stack>
        </Grid>

        <Grid item xs={12} md={4}>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} justifyContent={{ md: "flex-end" }}>
            <CommonButton
              variant="outline"
              size="small"
              component={Link}
              to={Path.help}
              onClick={() => history.push(Path.help)}
              startIcon={<HelpCircle size={16} />}
              sx={{ width: { xs: "100%", sm: "auto" }, textDecoration: "none" }}
            >
              Help & FAQs
            </CommonButton>

            <CommonButton
              variant="primary"
              size="small"
              component="a"
              href="mailto:info@autobetlottery.com"
              endIcon={<Send size={15} />}
              sx={{ width: { xs: "100%", sm: "auto" } }}
            >
              Email Support
            </CommonButton>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
};

export default TermsContactNotice;
